import { atom, selectorFamily } from 'recoil';
import { VehicleService } from 'api';
export const isVehicleAwaitingShippingRequestId = atom({
  key: 'isVehicleAwaitingShippingRequestId',
  default: 0
});
const isVehicleAwaitingShipping = selectorFamily({
  key: 'vehicleIsAwaitingShipping',
  get: ({
    registrationNumber,
    nationality
  }) => async ({
    get
  }) => {
    get(isVehicleAwaitingShippingRequestId);
    if (!registrationNumber || registrationNumber.length < 2) {
      return false;
    }
    const isAwaitingShippingResult = await VehicleService.isVehicleAwaitingShipping({
      body: {
        registrationNumber,
        registrationCountryCode: nationality
      }
    });
    return !!isAwaitingShippingResult?.isAwaitingShipping;
  }
});
export default isVehicleAwaitingShipping;